<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <slot name="navigation" />
      </v-col>
      <v-col cols="2">
        <payroll-payroll-cycle-transaction-detail-dialog-create
          v-if="$hasPermissionTo(['create payroll transactions'])"
          :payroll-cycle-transaction="payrollCycleTransaction"
          @created="loadPayrollCycleEmployees(payrollCycleTransaction.id)"
        />
      </v-col>
      <v-col cols="2">
        <import-payrolls-dialog-import
          v-if="$hasPermissionTo(['create payroll transactions'])"
          :payroll-cycle-transaction="payrollCycleTransaction"
          @imported="loadPayrollCycleEmployees(payrollCycleTransaction.id)"
        />
      </v-col>

      <v-col cols="2">
        <payroll-payroll-cycle-transaction-detail-dialog-batch-delete
          v-if="$hasPermissionTo(['create payroll transactions'])"
          :transactions="transactions"
          :payroll-cycle-transaction="payrollCycleTransaction"
          @deleted="loadPayrollCycleEmployees(payrollCycleTransaction.id)"
        />
      </v-col>
    </v-row>
    
    <v-row>
      <v-col class="pb-0">
        <v-text-field
          v-model="searchInput"
          placeholder="Filter employee by name"
          append-icon="search"
          label="Search Employee"
          hide-no-data
          hide-selected
        />
      </v-col>

      <v-col class="pb-0">
        <v-autocomplete
          v-model="company"
          label="Company Filter"
          placeholder="Company Filter"
          :items="companies"
          item-text="name"
          item-value="id"
          multiple
          chips
          small-chips
          clearable
          deletable-chips
        />
      </v-col>

      <v-col class="pb-0">
        <v-autocomplete
          v-model="deductionOrEarning"
          label="DOE Filter"
          placeholder="DOE Filter"
          :items="deductionOrEarnings"
          multiple
          item-text="name"
          item-value="id"
          chips
          small-chips
          clearable
          deletable-chips
        />
      </v-col>

      <v-col cols="12">
        <div
          class="summary-table-margin elevation-1 ma-0 my-3"
          style="background-color:#f5f5f5;width:100%"
        >
          <v-row no-gutters>
            <v-col class="text-center pt-2">
              <span class="font-weight-bold summary-header-font-size"><u>Batch Summary</u></span>
            </v-col>
          </v-row>

          <v-row class="px-4">
            <v-col cols="2">
              <span class="font-weight-bold">No of Companies:</span>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold">{{ filteredTransactions.length }}</span>
            </v-col>

            <v-col cols="2">
              <span class="font-weight-bold">Total Amount (RM):</span>
            </v-col>
            <v-col cols="2">
              <span class="font-weight-bold"> {{ currencyFormatting(calculateOverallCompanyTotal(filteredTransactions)) }}</span>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col
        v-if="changes.length > 0"
        cols="12"
        class="pt-0"
      >
        <v-alert
          border="left"
          colored-border
          color="error"
          style="background-color:#FFCCCB"
          elevation="1"
        >
          <h4 class="font-weight-bold mt-0">
            Today's manual insert/update transaction
          </h4>
          <div>
            <v-row
              no-gutters
              class="font-weight-bold"
            >
              <v-col>Employee Name</v-col>
              <v-col>Payroll Company</v-col>
              <v-col
                class="text-center"
                cols="3"
              >
                DOE
              </v-col>
              <v-col
                class="text-center"
                cols="2"
              >
                Amount (RM)
              </v-col>
            </v-row>
          </div>
          <div
            v-for="change in changes"
            :key="change.id"
          >
            <v-row no-gutters>
              <v-col>{{ change.company_employee.employee.person.name }}</v-col>
              <v-col>{{ change.company_employee.company.name }}</v-col>
              <v-col
                class="text-center"
                cols="3"
              >
                {{ change.deduction_or_earning.name }}
              </v-col>
              <v-col
                class="text-right"
                cols="2"
              >
                {{ thousandSeparator((Math.round((change.amount / 100) * 100) / 100).toFixed(2)) }}
              </v-col>
            </v-row>
          </div>
        </v-alert>
      </v-col>

      <v-col
        cols="12"
        class="pt-0"
      >
        <v-expansion-panels
          v-model="panel"
          multiple
          focusable
        >
          <v-expansion-panel
            v-for="(transaction,index) in filteredTransactions"
            :key="index"
            class="my-1"
          >
            <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
              {{ transaction.name }}
            </v-expansion-panel-header>
          
            <v-expansion-panel-content>
              <v-row class="px-0 font-weight-bold font-calibri">
                <v-col style="border-bottom:1px solid #000">
                  Transaction Date
                </v-col>
                <v-col style="border-bottom:1px solid #000">
                  Name
                </v-col>
                <v-col
                  class="text-center"
                  style="border-bottom:1px solid #000"
                >
                  Reference Code
                </v-col>
                <v-col
                  class="text-center"
                  style="border-bottom:1px solid #000"
                >
                  DOE
                </v-col>
                <!-- <v-col class="text-center">
                  Work Day Type
                </v-col>
                <v-col class="text-center">
                  Days
                </v-col>
                <v-col class="text-center">
                  Hours
                </v-col> -->
                <v-col
                  class="text-center"
                  style="border-bottom:1px solid #000"
                >
                  Amount(RM)
                </v-col>

                <v-col
                  cols="1"
                  style="border-bottom:1px solid #000"
                />
              </v-row>

              <v-row
                v-for="(detail,index) in (searchInput || deductionOrEarning.length > 0)?transaction.customed_payroll_transaction_details : transaction.payroll_transaction_details"
                :key="index"
                class="font-calibri"
              >
                <v-col
                  class="py-0"
                  :class="{
                    'delete font-weight-bold':detail.deleted_at
                  }"
                >
                  {{ detail.transaction_date }}
                </v-col>
                <v-col
                  class="py-0"
                  :class="{
                    'delete font-weight-bold':detail.deleted_at
                  }"
                >
                  {{ detail.company_employee.employee.person.name }}
                </v-col>
                <v-col
                  class="py-0 text-center"
                  :class="{
                    'delete font-weight-bold':detail.deleted_at
                  }"
                >
                  {{ detail.reference_code }}
                </v-col>
                <v-col
                  class="py-0 text-center"
                  :class="{
                    'delete font-weight-bold':detail.deleted_at
                  }"
                >
                  {{ detail.deduction_or_earning.name }}
                </v-col>
                <!-- <v-col class="py-0 text-center">
                  {{ detail.work_day_type ? detail.work_day_type:'N/A' }}
                </v-col>
                <v-col class="py-0 text-center">
                  {{ detail.day ? detail.day:'N/A' }}
                </v-col>
                <v-col class="py-0 text-center">
                  {{ detail.hour ? detail.hour:'N/A' }}
                </v-col> -->
                <v-col
                  class="py-0 text-right"
                  :class="{
                    'delete font-weight-bold':detail.deleted_at
                  }"
                >
                  <span v-if="detail.amount && detail.deduction_or_earning.is_negative!==0">-</span>
                  {{ detail.amount ? currencyFormatting(detail.amount) : 'N/A' }}
                </v-col>

                <v-col
                  class="py-0 text-left"
                  cols="1"
                >
                  <payroll-payroll-cycle-transaction-detail-dialog-edit
                    v-if="!detail.deleted_at"
                    :payroll-transaction-detail="detail"
                    @updated="loadPayrollCycleEmployees(payrollCycleTransaction.id)"
                  />
                  <payroll-payroll-cycle-transaction-detail-dialog-delete
                    v-if="!detail.deleted_at"
                    :payroll-transaction-detail="detail"
                    @deleted="loadPayrollCycleEmployees(payrollCycleTransaction.id)"
                  />
                  <v-tooltip
                    v-if="detail.remark"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="info">
                          mdi-information-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>{{ detail.remark }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row v-if="transaction.payroll_transaction_details.length<1">
                <v-col
                  cols="12"
                  class="py-0"
                >
                  <span>No data available</span>
                </v-col>
              </v-row>

              <v-row class="px-0 font-weight-bold font-calibri">
                <v-col style="border-top:1px solid #000" />
                <v-col style="border-top:1px solid #000" />
                <v-col style="border-top:1px solid #000" />
                <v-col style="border-top:1px solid #000" />
                <v-col style="border-top:1px solid #000" />
          
                <v-col
                  class="text-center"
                  style="border-top:1px solid #000;border-bottom:3px double #000"
                >
                  TOTAL
                </v-col>

                <v-col
                  class="text-right"
                  style="border-top:1px solid #000;border-bottom:3px double #000"
                >
                  {{ currencyFormatting(calculateCompanyTotal((searchInput || deductionOrEarning.length > 0) ? transaction.customed_payroll_transaction_details : transaction.payroll_transaction_details)) }}
                </v-col>
            
                <!-- <v-col class="text-center">
                  Work Day Type
                </v-col>
                <v-col class="text-center">
                  Days
                </v-col>
                <v-col class="text-center">
                  Hours
                </v-col> -->

                <v-col
                  style="border-top:1px solid #000;border-bottom:3px double #000"
                  cols="1"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      ImportPayrollsDialogImport: () => import('@/components/import/payrolls/DialogImport'),
      PayrollPayrollCycleTransactionDetailDialogCreate: () => import('@/components/hris/payroll/payroll-cycle/transaction-detail/DialogCreate'),
      PayrollPayrollCycleTransactionDetailDialogDelete: () => import('@/components/hris/payroll/payroll-cycle/transaction-detail/DialogDelete'),
      PayrollPayrollCycleTransactionDetailDialogEdit: () => import('@/components/hris/payroll/payroll-cycle/transaction-detail/DialogEdit'),
      PayrollPayrollCycleTransactionDetailDialogBatchDelete: () => import('@/components/hris/payroll/payroll-cycle/transaction-detail/DialogBatchDelete'),
    },

    props: {
      payrollCycleTransaction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        transactions: [],
        loading: false,
        // panel: [],
        searchInput: '',
        company: [],
        companies: [],
        deductionOrEarning: [],
        deductionOrEarnings: [],
        changes: [],
        pcTransactionId: null,
      }
    },
    computed: {
      filteredTransactions () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()

        let filteredCompanies = this.customCompanyFilter(this.transactions)
        let filteredDoes = this.customDoeFilter(filteredCompanies)
        let primaryEmployeeSearch = this.customSearch(filteredDoes, _this.searchInput)

        return primaryEmployeeSearch
      },

      panel () {
        let array = []
        for (let i = 0; i < this.filteredTransactions.length; i++) {
          array.push(i)
        }

        return array
      },
    },

    watch: {
      payrollCycleTransaction (value) {
        if (value) {
          this.company = []
          this.deductionOrEarning = []
          this.searchInput = ''
        }
      },
    },

    created () {
      this.loadPayrollCompanies()
      this.loadDeductionOrEarnings()
    },

    methods: {
      loadPayrollCycleEmployees (payrollCycleTransactionId) {
        this.loading = true
        
        this.pcTransactionId = payrollCycleTransactionId

        this.$api.payrollCycleTransactions().show(payrollCycleTransactionId)
          .then(res => {
            this.transactions = _.orderBy(res.data, ['name', 'company_employee.employee.person.name'], ['asc', 'asc'])

            for (let i = 0; i < this.transactions.length; i++) {
              this.panel.push(i)
            }

            this.loading = false
          })

        this.loadPayrollTransactionDetailChanges(payrollCycleTransactionId)
      },

      customSearch (transactions, searchInput) {      
        if (!searchInput || searchInput.length < 1) return transactions

        return transactions.filter(transaction => {
          if (transaction.customed_payroll_transaction_details && transaction.customed_payroll_transaction_details.length > 0 && (searchInput || this.deductionOrEarning.length > 0)) {
            transaction.customed_payroll_transaction_details = transaction.customed_payroll_transaction_details.filter(detail => {
              return detail.company_employee.employee.person.name.toLowerCase().indexOf(searchInput.toLowerCase()) !== -1 
            })
          } else {
            transaction.customed_payroll_transaction_details = transaction.payroll_transaction_details.filter(detail => {
              return detail.company_employee.employee.person.name.toLowerCase().indexOf(searchInput.toLowerCase()) !== -1 
            })
          }

          return transaction.customed_payroll_transaction_details.length > 0
        })
      },

      customCompanyFilter (transactions) {
        if (this.company.length === 0) return transactions

        return transactions.filter(transaction => {
          let companyId = transaction.id
     
          return _.intersection([companyId], this.company).length > 0
        })
      },

      customDoeFilter (transactions) {
        if (this.deductionOrEarning.length === 0) return transactions

        return transactions.filter(transaction => {
          transaction.customed_payroll_transaction_details = transaction.payroll_transaction_details.filter(detail => {
            let doeId = detail.deduction_or_earning_id

            return _.intersection([doeId], this.deductionOrEarning).length > 0
          })

          return transaction.customed_payroll_transaction_details.length > 0
        })
      },

      calculateCompanyTotal (transactionDetails) {
        let sum = 0
        for (let item in transactionDetails) {
          if (!transactionDetails[item].deleted_at) {
            if (transactionDetails[item].deduction_or_earning.is_negative === 0) {
              sum = parseInt(sum) + parseInt(transactionDetails[item].amount)
            } else {
              sum = parseInt(sum) - parseInt(transactionDetails[item].amount)
            }
          }
        }
        return sum
      },

      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },

      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },

      loadPayrollCompanies () {
        this.$api.hrisCompanies().list()
          .then(res => {
            this.companies = _.orderBy(res.data, ['name'], ['asc'])
          })
      },

      loadDeductionOrEarnings () {
        this.$api.deductionOrEarnings().list()
          .then(res => {
            this.deductionOrEarnings = _.orderBy(res.data, ['name'], ['asc'])
          })
      },

      calculateOverallCompanyTotal (transactions) {
        let sum = 0

        transactions.forEach(transaction => {
          if ((this.searchInput || this.deductionOrEarning.length > 0)) {
            for (let item in transaction.customed_payroll_transaction_details) {
              if (!transaction.payroll_transaction_details[item].deleted_at) {
                if (transaction.customed_payroll_transaction_details[item].deduction_or_earning.is_negative === 0) {
                  sum = parseInt(sum) + parseInt(transaction.customed_payroll_transaction_details[item].amount)
                } else {
                  sum = parseInt(sum) - parseInt(transaction.customed_payroll_transaction_details[item].amount)
                }
              }
            }
          } else {
            for (let item in transaction.payroll_transaction_details) {
              if (!transaction.payroll_transaction_details[item].deleted_at) {
                if (transaction.payroll_transaction_details[item].deduction_or_earning.is_negative === 0) {
                  sum = parseInt(sum) + parseInt(transaction.payroll_transaction_details[item].amount)
                } else {
                  sum = parseInt(sum) - parseInt(transaction.payroll_transaction_details[item].amount)
                }
              }
            }
          }
        })
     
        return sum
      },

      loadPayrollTransactionDetailChanges ($payrollCycleTransactionId) {
        this.$api.payrollTransactionDetails().listChanges($payrollCycleTransactionId)
          .then(res => {
            this.changes = _.orderBy(res.data, ['company_employee.company.name', 'company_employee.employee.person.name'], ['asc', 'asc'])
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.summary-table-margin{
  margin:20px;
  border-radius:10px;
}

.v-expansion-panel-header--active{
  color: #469aff;
}

.delete{
  color: #00d3ee;
}
</style>
